import { DefaultState } from 'store/types';

export const CANCEL_LODGING_REQUEST_REQUEST = 'CANCEL_LODGING_REQUEST_REQUEST';
export const CANCEL_LODGING_REQUEST_SUCCESS = 'CANCEL_LODGING_REQUEST_SUCCESS';
export const CANCEL_LODGING_REQUEST_FAILURE = 'CANCEL_LODGING_REQUEST_FAILURE';

export interface CancelLodgingRequestData {
  
}

export type CancelLodgingRequestState = DefaultState & {
  contents?: CancelLodgingRequestData;
};

interface ReadCancelLodgingRequestDataRequest {
  type: typeof CANCEL_LODGING_REQUEST_REQUEST;
};

interface ReadCancelLodgingRequestDataSuccess {
  type: typeof CANCEL_LODGING_REQUEST_SUCCESS,
  contents: CancelLodgingRequestData;
}

interface ReadCancelLodgingRequestDataFailure {
  type: typeof CANCEL_LODGING_REQUEST_FAILURE;
}

export type CancelLodgingRequestActionTypes = ReadCancelLodgingRequestDataRequest | ReadCancelLodgingRequestDataSuccess | ReadCancelLodgingRequestDataFailure;